// removed by extract-text-webpack-plugin
module.exports = {"wrap-download-app":"wrap-download-app","download-app-text":"download-app-text","download-app-icon":"download-app-icon"};


//////////////////
// WEBPACK FOOTER
// ./components/layouts/master/sub-header/_DownloadApp.scss
// module id = ./components/layouts/master/sub-header/_DownloadApp.scss
// module chunks = 0